import { css, cva } from '@/styled-system/css';

// The location pill, shared by the search bar's field (LocationInput) and the location dialog's field.

const PILL_BG = 'bg.action.neutral.alt.default';

// Raw so the dialog's AdornedInput can merge it; it repaints on focus, so the fill is pinned there too.
export const locationPillSurface = css.raw({
  borderRadius: 'pill',
  backgroundColor: PILL_BG,
  _focusWithin: { backgroundColor: PILL_BG },
});

export const locationPillPlaceholder = css.raw({ color: 'text.subtle', fontWeight: 'regular' });

export const locationPillValue = css.raw({ fontWeight: 'bold' });

export const locationPillInput = css.raw({ fontWeight: 'bold', _placeholder: locationPillPlaceholder });

// The bar's field layout; `start` and `both` match what LocationCombobox resolves to at the same size.
export const locationPillLayout = cva({
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: 'tighter',
    width: '100%',
    minWidth: 0,
    paddingBlock: 'tighter',
  },
  variants: {
    inset: {
      both: { paddingInline: 'default' },
      start: { paddingInlineStart: 'default' },
    },
  },
  defaultVariants: {
    inset: 'start',
  },
});

// Constellation's tap-area overlay from its `sm` Button: a 44px hit area without a taller box.
export const locationPillTapArea = css({
  position: 'relative',
  _after: {
    content: '""',
    position: 'absolute',
    height: 'tapArea.mobile.default',
    minWidth: 'tapArea.mobile.default',
    width: '100%',
    left: '0',
    top: '50%',
    marginTop: 'calc(({sizes.tapArea.mobile.default} / 2) * -1)',
  },
});
